module.exports = __webpack_public_path__ + "img/emoji_36.155327e7.png";